module.exports = __webpack_public_path__ + "images/ui-grid_fc8a2b48ae523377a181be3813d58c31.ttf";